// 土耳其
module.exports = {
  common: {
    edit: "düzenlemek",
    apply: "Uygula",
    activate: "aktivasyon",
    delete: "silmek",
    cancel: "İptal etmek",
    success: "başarı",
    fail: "hata",
    save: "kaydetmek",
    ensure: "Elbette",
    submit: "göndermek",
    remark: "Açıklama",
    detail: "Kontrol etmek",
    action: "çalıştır",
    open: "açık",
    close: "kapatma",
    back: "geri dönmek",
    export: "ihracat",
    modify: "Tekrar düzeltme yapmak",
    layout: "oturumu Kapat",
    noListData: "Listede veri yok",
    more: "Detaylar",
    add: "Eklemek",
    delSuccess: "başarıyla silindi!",
    addFailure: "ekleme başarısız!",
    logOut: "çıkış Yap",
    delAllInfo: "Silme işlemine devam etmek istiyor musunuz?",
    saveTip:
      "Sayfanın içeriğini kaydetmediniz, ayrılmaya devam etmek istiyor musunuz?",
    tip: "ipucu",
    yes: "Evet",
    no: "HAYIR",
    delTip: "Etkinleştirmek için kontrol edin",
    batchDelete: "toplu silme",
    search: "Sormak",
    permission: "Henüz izin yok, lütfen geri dönün",
    reset: "Sıfırla",
  },
  breadcrumbItem: {
    home: "Ad Listesi Yapılandırması",
    data: "Cihaz genel yapılandırma paketi",
    alarm: "Bölge yapılandırması",
    house: "Ev düzeni yapılandırması",
    name: "Ad Listesi Yapılandırması",
  },
  errorRes: {
    res82: "Sistem meşgul, lütfen daha sonra tekrar deneyiniz",
  },
  openConfig: {
    title: "Cihaz Genel Yapılandırması",
    version: "Protokol Sürümü",
    versionTip: "Lütfen bir protokol sürümü seçin",
    checkVersion: "Protokol sürümü boş olamaz, lütfen tekrar seçiniz",
    signType: "İmza Algoritması Türü",
    checkSignType: "İmza algoritma türü boş bırakılamaz, lütfen tekrar seçiniz",
    fileLabel: "Bir belge seçin",
    addFile: "dosya Ekle",
    fileName: "dosya adı",
    zipType: "Sıkıştırma yöntemi",
    noZip: "sıkıştırma yok",
    noFile: "Henüz dosya eklenmemiş",
    checkFile: "Yapılandırma dosyası boş, lütfen bir dosya ekleyin",
    name: "isim",
    nameTip: "Giriş uzunluğu 1-10 hanedir",
    checkName: "İsim boş bırakılamaz, lütfen tekrar giriniz",
    checkName1: "Yanlış isim girişi, lütfen tekrar giriniz",
    room: "cihaz kimliği",
    roomTip: 'Giriş uzunluğu 1-24 bittir ve seviye "-" ile ayırt edilir',
    checkRoom: "Cihaz numarası boş geçilemez, lütfen tekrar giriniz",
    checkRoom1: "Cihaz numarası girişi yanlış, lütfen tekrar giriniz",
    pic: "resim",
    add: "A ekle",
    reset: "Sıfırla",
    picTip: "Bir resim dosyasının maksimum yükleme boyutu 3m'dir",
    checkPic: "Resim dosyası boş olamaz, lütfen yeniden seçiniz",
    imgRegTip: "Yalnızca jpg, jpeg, png formatındaki dosyaları yükleyin",
    excRegTip: "Yalnızca xls ve xlsx formatındaki dosyaları yükleyin",
    zipRegTip: "Yalnızca zip formatındaki dosyaları yükleyin",
    produce: "Yapılandırma dosyası oluştur",
    confType: "Yapılandırma Tipi",
    pack: "Ambalaj",
    batchAdd: "Toplu Ekle",
    singleAdd: "Tek Ekle",
    modelBatch: "Toplu içe aktarma şablonunu indir",
    uploadInfo: "Temel bilgileri Excel'e yükleyin",
    uploadPic: "Zip resim paketini yükle",
    addName: "Tek bir veri parçası ekle",
    sameTip: "Seri numarası:",
    sameTip1: "Yinelenen cihaz numarası",
    modelError:
      "Yüklenen temel bilgi dosyasının içeriği yanlış, lütfen dosyayı şablona göre düzenleyiniz",
    noPic:
      "Listede resimlerle eklenmemiş veriler var, konfigürasyon dosyasını oluşturmadan önce resimleri tamamlamanız gerekiyor",
    picBtnTip: "Lütfen önce temel bilgi dosyasını yükleyin",
    devType: "Ekipman Türü",
    devTypeTip: "Lütfen bir cihaz türü seçin",
    checkDevType: "Cihaz tipi boş bırakılamaz, lütfen tekrar seçiniz",
    indexName: "seri numarası",
    IS: "İç ünite",
    GU: "Yönetim makinesi",
    OS1: "Ses İstasyonu",
    OS2: "Duvar Makinesi",
    OS3: "Küçük Kapı İstasyonu",
    nameListTip:
      "Yüklenen temel verilerde, adı alanı eksik olan veriler var ve geri kalan doğru veriler içe aktarıldı",
    numListTip:
      "Yüklenen temel verilerde, cihaz numarası alanında eksik veriler var, geri kalan doğru veriler içe aktarıldı",
  },
  alarm: {
    ad: "AD bölgesi",
    io: "GÇ bölgesi",
    alarmPlus: "Bölge Genişletme",
    num: "seri numarası",
    open: "açık",
    close: "kapalı",
    machine: "Dedektör Tipi",
    sendType: "Tetikleyici Tipi",
    mode: "model",
    mType1: "kızılötesi",
    mType2: "Kapı Manyetik",
    mType3: "pencere mıknatısı",
    mType4: "gaz",
    mType5: "Sigara içmek",
    mType6: "kapı zili",
    mType7: "Bülten Düğmesi",
    mType8: "Kızılötesi Kapı Sensörü",
    mType9: "El alarmı kapı sensörü",
    mType10: "titreşim",
    mType11: "hava basıncı",
    mType12: "diğer",
    send1: "24 saat içinde hemen bildir",
    send2: "Gecikmeli alarm",
    send3: "Aktarım Gecikmesi",
    send4: "Derhal polisi arayın",
    send5: "Çapraz Alarm",
    mode1: "Normalde açık",
    mode2: "Genellikle kapalı",
    presence: "evde",
    leaving: "evden ayrılmak",
    timeSet: "Arma ile ilgili zaman ayarı",
    delayTime: "Kurma efektif gecikmesi (saniye)",
    startDelay: "Alarm tetikleme gecikmesi (saniye)",
    startUtil: "Alarm süresi (dakika)",
    associated: "İlişkili Bölge",
  },
  house: {
    dev: "teçhizat",
    scene: "Sahneler",
    vine: "sensör",
    single: "Sahnelerin bağımsız kontrolü",
    light: "ışık",
    air: "klima",
    heat: "yerden ısıtma",
    fresh: "Taze Rüzgar",
    switch: "Anahtar Priz",
    curtain: "perde",
    water: "su ısıtıcı",
    bgm: "Arka plan müziği",
    cust: "Özel Cihaz",
    slight: "ışık",
    sAir: "klima",
    sHeat: "yerden ısıtma",
    sFresh: "Taze Rüzgar",
    sSwitch: "Anahtar Priz",
    sCurtain: "perde",
    sWater: "su ısıtıcı",
    sBgm: "Arka plan müziği",
    sCust: "Özel Cihaz",
    IndependentControl: "Sahnelerin bağımsız kontrolü",
    scene1: "sahne 1",
    scene2: "Sahne 2",
    scene3: "Sahne 3",
    scene4: "Sahne 4",
    scene5: "Sahne 5",
    scene6: "Sahne 6",
    scene7: "Sahne 7",
    scene8: "Sahne 8",
    temp1: "sıcaklık",
    temp2: "nem",
    temp3: "metan",
    temp4: "organik gaz",
    picTip: "Kat planı yok",
    upload: "Kat planını yükle",
    imgSize: "Tek kat planının görüntü boyutu 10M'yi geçmemelidir",
    imgName:
      "Yüklenen kat planı dosyasının adı Çince görünmemelidir, lütfen tekrar seçiniz",
    imgLength:
      "Toplam kat planı yükleme ve ekleme sayısı 8'i geçmemelidir ve klasördeki ilk 8 resim otomatik olarak seçilmiştir",
    imgCheckTip: "Kat planı uymuyor, lütfen yeniden yükleyin",
    room1: "Ev Tipi 1",
    room2: "Ev Tipi 2",
    room3: "Ev Tipi 3",
    room4: "Ev Tipi 4",
    room5: "Ev Tipi 5",
    room6: "Ev Tipi 6",
    room7: "Ev Tipi 7",
    room8: "Ev Tipi Şekil 8",
    download: "ihracat",
    input: "Yapılandırmayı içe aktar",
    title: "Ekipman parametre tablosu",
    name: "isim",
    location: "Konum",
    start: "başlatmak",
    see: "görünür",
    noSee: "Görünmez",
    belong: "ait olmak",
    bgIcon: "Mavi Gri İkon",
    vineTip:
      "Lütfen sıcaklık kontrol özelliklerini ayarlamadan önce kat planını seçin",
    sceneTip:
      "Lütfen kat planını seçin ve ardından sahne özelliklerini ayarlayın",
    dragTip:
      "Lütfen sürükleme işlemini gerçekleştirmeden önce kat planını seçiniz",
    editTip: "Başarıyla düzenlendi",
    addTip: "Yükleme yaparken tüm kat planlarını aynı anda seçmeniz gerekiyor",
    editError: "Düzenlemeden önce lütfen düzenleme içeriğini belirtin",
    delError: "Lütfen silmeden önce silinecek içeriği belirtin",
    delTip: "başarıyla silindi",
    imgAddTip:
      "Yüklenen ve eklenen toplam kat planı sayısı 8'e ulaştı ve daha fazla eklenemez",
    houseTitle: "Ev tipi harita değiştirme:",
    delHouseTip:
      "Bu işlem kat planını ve konfigürasyon içeriğini silecek. Devam etmek istiyor musunuz?",
    sendTip:
      "Tekrar değiştirmek için yapılandırma içeriğini içe aktarın, xml dosyasını yükleyebilirsiniz",
    checkType:
      "Yüklenen dosyanın biçimi yanlış, lütfen dosya içeriğini kontrol edin ve tekrar yükleyin",
    importTip: "Yapılandırma dosyasını içe aktar",
    importTip1: "İlgili kat planını içe aktar",
    upLoadBtn: "Yüklemek",
    picContent:
      "Kat planlarını yükleme sırası, konfigürasyon dosyasındaki kat planlarının sırası ile tutarlı olmalıdır",
    successFile: "Yapılandırma dosyası başarıyla yüklendi",
    vineTipCheck: "Ad boş olamaz, lütfen girişi onaylayın",
    picNumMax:
      "Lütfen içe aktarılan resimlerin sayısını onaylayın. İçe aktarılan resimlerin mevcut sayısı, yapılandırma dosyasındaki ev planı sayısından fazla. Lütfen yeniden seçin",
    picNumMin:
      "Lütfen içe aktarılan resim sayısını onaylayın. İçe aktarılan mevcut resim sayısı, yapılandırma dosyasındaki ev planı sayısından az. Lütfen tekrar seçin",
    maxSizeTip:
      "Bu türden eklemelerin sayısı veya toplam sayısı sınırı aşıyor. Eklemeniz gerekiyorsa, lütfen önce eklenen cihazları veya sahneleri sıralayın.",
    devNameTip: "Lütfen bir isim giriniz",
    chromeTip: "Chrome tarayıcı önerilir",
    downTip: "İndirme bağlantısına atlamak için tıklayın",
    imgRegTip: "Yalnızca jpg ve jpeg formatındaki dosyaları yükleyin",
    threeTitle: "Üç sabit sistem",
    mainControl: "usta",
    sedControl: "alt kontrol",
    controlBtn: "Yapılandırma",
    configEdit: "Sanheng sistem yapılandırma ayrıntıları",
    moveTip:
      "Lütfen ikonu kat planı alanına sürükleyin, lütfen tekrar sürükleyin",
    repeatNameTip:
      "Aynı isimli kat planları yüklenemiyor, lütfen tekrar seçiniz",
    space: "(Rezerve)",
  },
  updateConfig: {
    tip0: "24 saatlik alarmı ayarlarken anahtarı AÇIK konumuna getirin",
    tip1: "24 saat alarmı ayarlanırken anahtar açık konuma getirilmelidir",
    tip2: "Acil bir alarm ayarlarken, anahtar açık konuma getirilmelidir",
    tip3: "Gecikme alarmı kapalıyken teslimat gecikmesinin kapalı olarak ayarlanması gerekir",
    tip4: "Çapraz alarm ayarlandı, ilişkili işlem gerekiyor",
    tip5: "Lütfen önce gecikme alarmını açın",
    tip6: "Acil alarm ayarlarken anahtarı açık konuma getirin",
  },
  audio: {
    title: "Ses İpucu Paketleme Aracı",
    lock: "Kilit Açma Ses İpucu",
    call: "Çağrı Ses İpucu",
    speak: "Konuşma Ses İpucu",
    busy: "Meşgul Ses İpucu",
    tip1: ".wav formatındaki dosyayı yüklemek için tıklayın",
    tip2: "Dosya boyutu 1 MB'yi geçmemelidir",
    tip3: "Lütfen .wav formatında dosya yükleyin",
    tip4: "Lütfen tüm dosyaları yükleyin",
    add: "Dosyaları Oluştur",
  },
  threeProject: {
    hotWater: "Isıqlı su sistemi",
    cho: "Formaldehid",
    config: "Yerləşdirmək",
    unconfig: "Yerləşdirməmək",
  },

  elevator: {
    title: "Asansör Kontrol Yapılandırması Oluşturucu",
    label: "Asansör Kontrol Yapılandırma Tablosu Yükle",
    uploadTip: "Yüklemek için dosyayı bu alana tıklayın veya sürükleyin",
    upload: "Yükle",
    download: "Şablon İndir",
    downloadTip:
      "Asansör kontrol yapılandırma şablonunu indirmek için tıklayın",
    error1:
      "[Fiziksel Kat] hatalı. Lütfen yapılandırma dosyasını kontrol edin ve yeniden içe aktarın.",
    error2:
      "[Görünen Kat] hatalı. Lütfen yapılandırma dosyasını kontrol edin ve yeniden içe aktarın.",
    error3:
      "[Asansör Kontrol Geçidi Adresi] hatalı. Lütfen yapılandırma dosyasını kontrol edin ve yeniden içe aktarın.",
    error4:
      "[Asansör Numarası Görüntüleme] hatalı. Lütfen yapılandırma dosyasını kontrol edin ve yeniden içe aktarın.",
    error5:
      "[Cihaz IP] hatalı. Lütfen yapılandırma dosyasını kontrol edin ve yeniden içe aktarın.",
    error6:
      "[Asansör Kontrol Geçidi] sayısı sınıra ulaştı. Lütfen yapılandırma dosyasını kontrol edin ve yeniden içe aktarın.",
    generate: "Asansör Kontrol Yapılandırma Şablonu",
    fileLabel: "Asansör Kontrol Yapılandırma Dosyası:",
    tip: "Yapılandırma dosyasını, PC aracındaki [Kaynak Yükseltme] bölümüne yerleştirerek cihaza içe aktarın.",
    downloadfile: "İndir",
    fileName: "AsansorKontrolYapilandirma.xlsx",
    formatError:
      "Yüklenen dosya biçimi hatalı, lütfen dosya içeriğini kontrol edin ve yeniden yükleyin",
  },
};
